import React from 'react';
import PropTypes from 'prop-types';
import { Paper, Typography, Grid } from '@esgian/esgianui';
import PortCallShareChart from '@components/Sections/ShipAnalytics/PortProfileSection/SubSections/PortOperatorStatisticsSection/PortCallShareChart';
import { getTop10Calls } from '@helpers/statisticsCalculationHelpers';

function CompanyPortChart({ loading = false, fileName = '', statsData = null, showYTD = false }) {
  const chartOpsCurrent = getTop10Calls(
    statsData?.shareOfTransits ?? [],
    'shareCurrentYear',
    'shareCurrentYear',
    true
  );
  const chartOpsPrevious = getTop10Calls(
    statsData?.shareOfTransits ?? [],
    'sharePreviousYear',
    'sharePreviousYear',
    true
  );

  if (chartOpsPrevious[10]) {
    chartOpsPrevious[10].portName = 'Others';
    chartOpsPrevious[10].portId = 0;
  }

  if (chartOpsCurrent[10]) {
    chartOpsCurrent[10].portName = 'Others';
    chartOpsCurrent[10].portId = 0;
  }

  const chartExistsPrev = chartOpsPrevious.some((row) => row.sharePreviousYear > 0);
  const chartExistsCur = chartOpsCurrent.some((row) => row.shareCurrentYear > 0);

  return (
    <Paper sx={{ p: 2 }}>
      <Grid container spacing={2}>
        {chartExistsPrev && (
          <Grid item xs={6}>
            <Typography variant={'h6'}>
              {showYTD ? 'YTD ' : ''}
              {statsData?.previousYear}
            </Typography>
            <PortCallShareChart
              fileName={fileName}
              categories={[
                ...chartOpsPrevious.map(({ portName }) => {
                  return portName;
                })
              ]}
              seriesData={[
                ...chartOpsPrevious.map(({ sharePreviousYear }) => {
                  return Number(sharePreviousYear);
                })
              ]}
              selectedYear={statsData?.previousYear}
              id={'-prev-year-ytd-chart'}
              loading={loading}
            />
          </Grid>
        )}
        {chartExistsCur && (
          <Grid item xs={6}>
            <Typography variant={'h6'}>
              {showYTD ? 'YTD ' : ''}
              {statsData?.year}
            </Typography>
            <PortCallShareChart
              fileName={fileName}
              categories={[
                ...chartOpsCurrent.map(({ portName }) => {
                  return portName;
                })
              ]}
              seriesData={[
                ...chartOpsCurrent.map(({ shareCurrentYear }) => {
                  return Number(shareCurrentYear);
                })
              ]}
              selectedYear={statsData?.year}
              id={'-ytd-chart'}
              loading={loading}
            />
          </Grid>
        )}
      </Grid>
    </Paper>
  );
}

CompanyPortChart.propTypes = {
  loading: PropTypes.bool,
  fileName: PropTypes.string,
  statsData: PropTypes.object,
  showYTD: PropTypes.bool
};

export default CompanyPortChart;
